// ═══════════════════════════════════════════════════════════════════════════
// @dxf-ai-editor/command-registry — descriptor aggregator
// ═══════════════════════════════════════════════════════════════════════════
//
// Aggregates per-category descriptor arrays into a single
// `ALL_COMMAND_DESCRIPTORS` constant consumed by the public barrel.
//
// PARALLEL-WORK NOTE (2026-04-23): the per-category files
// (`drawing.ts`, `modify.ts`, `dimension.ts`, `annotation.ts`, `block.ts`,
// `attribute.ts`, `array.ts`, `layout.ts`, `dynamic.ts`, `reference.ts`,
// `system.ts`) were authored in parallel by Sub-B/Sub-C/Sub-Cmd1..4 and
// have all landed. Imports below are active.
//
// When a new category file lands, add its line in BOTH the import block
// and the array literal below in the same edit. Keep the alphabetical
// order so git diffs stay minimal.
// ═══════════════════════════════════════════════════════════════════════════

import type { CommandDescriptor } from "../types.js";

import { ANNOTATION_DESCRIPTORS } from "./annotation.js";
import { ARRAY_DESCRIPTORS } from "./array.js";
import { ATTRIBUTE_DESCRIPTORS } from "./attribute.js";
import { BLOCK_DESCRIPTORS } from "./block.js";
import { COLLAB_DESCRIPTORS } from "./collab.js";
import { DIMENSION_DESCRIPTORS } from "./dimension.js";
import { DRAWING_DESCRIPTORS } from "./drawing.js";
import { DYNAMIC_DESCRIPTORS } from "./dynamic.js";
import { DYNAMIC_AUTHORING_DESCRIPTORS } from "./dynamicAuthoring.js";
import { LAYOUT_DESCRIPTORS } from "./layout.js";
import { MODIFY_DESCRIPTORS } from "./modify.js";
import { REFERENCE_DESCRIPTORS } from "./reference.js";
import { SYSTEM_DESCRIPTORS } from "./system.js";
import { SYSTEM_DIALOG_DESCRIPTORS } from "./systemDialogs.js";
import { SYSTEM_HISTORY_DESCRIPTORS } from "./systemHistory.js";

export const ALL_COMMAND_DESCRIPTORS: readonly CommandDescriptor[] = [
  ...ANNOTATION_DESCRIPTORS,
  ...ARRAY_DESCRIPTORS,
  ...ATTRIBUTE_DESCRIPTORS,
  ...BLOCK_DESCRIPTORS,
  ...COLLAB_DESCRIPTORS,
  ...DIMENSION_DESCRIPTORS,
  ...DRAWING_DESCRIPTORS,
  ...DYNAMIC_DESCRIPTORS,
  ...DYNAMIC_AUTHORING_DESCRIPTORS,
  ...LAYOUT_DESCRIPTORS,
  ...MODIFY_DESCRIPTORS,
  ...REFERENCE_DESCRIPTORS,
  ...SYSTEM_DESCRIPTORS,
  ...SYSTEM_DIALOG_DESCRIPTORS,
  ...SYSTEM_HISTORY_DESCRIPTORS,
];
